/**
 * Created by intellicar-rinas on 4/10/17.
 */
import {
  schemaTypes,
  dateFormat,
  fuelTypeMap,
} from "../../../constants/constants";
import ReportAPIs from "../../../APIs/ReportAPIs";
import GeoCodeAPIs from "../../../APIs/GeoCodeAPIs";
import { JSONToCSVConvertor, stripLoc } from "../../../helpers/helperFunctions";
import {
  canShowRangeSwitch,
  flipRange,
  onFetchOdo,
  changeVehicle,
} from "./historyReport/historyReport";
import moment from "moment";
import _ from "lodash";
import { getFuelPrices } from "./tripReport";
import { changeToHours } from "../reports/dailyReport";

const processData = (respObj, vehicleMap, callback) => {
  let historyData = [];
  let locationData = [];

  for (let vehiclepath in respObj) {
    vehiclepath = parseInt(vehiclepath,10)
    if(!vehicleMap[vehiclepath]) continue
    let vehicleno = vehicleMap[vehiclepath].vehicleno;
    let model = vehicleMap[vehiclepath].vehicleModel
      ? vehicleMap[vehiclepath].vehicleModel.model
      : vehicleMap[vehiclepath].vehiclemeta
      ? vehicleMap[vehiclepath].vehiclemeta.model || ""
      : "";

    for (let ridx in respObj[vehiclepath]) {
      let eachitem = respObj[vehiclepath][ridx];
      let time = parseInt(eachitem.time, 10);
      let alarmtype = eachitem.alarmtype;
      let lat = eachitem.lat != null ? eachitem.lat : "";
      let lng = eachitem.lng != null ? eachitem.lng : "";
      let alti =
        eachitem.alti != null ? parseFloat(eachitem.alti.toFixed(2)) : "";
      let heading =
        eachitem.heading != null ? parseFloat(eachitem.heading.toFixed(2)) : "";
      let numsat = eachitem.numsat != null ? eachitem.numsat : "";
      let speed = eachitem.speed != null ? parseInt(eachitem.speed, 10) : "";
      let executedby = eachitem.executedby ? eachitem.executedby : "";
      let location = lat + "," + lng;
      locationData.push([eachitem.lat, eachitem.lng]);
      historyData.push({
        time,
        alarmtype,
        lat,
        lng,
        alti,
        heading,
        numsat,
        speed,
        vehicleno,
        model,
        executedby,
        location,
      });
    }
  }

  callback(historyData);
  // GeoCodeAPIs.getAddress(locationData)
  //     .then((resp)=>{
  //         for(let idx in historyData){
  //             if(resp[idx][1] != "unknown")
  //                 historyData[idx].location = (resp[idx] ? resp[idx][1] : '') + ' (' + historyData[idx].lat +" , "+ historyData[idx].lng + ')';
  //         }
  //         callback(historyData);
  //     },(resp)=>{console.log(resp)});
};

const getHistory = (schema, data, store) => {
  let saveState = null;
  let tableStateData = null;
  const handleSuccess = (resp) => {
    if (window.setReportWindowTabBusy)
      window.setReportWindowTabBusy(schema, false);
    processData(resp, store.vehicleMap, (data) => {
      schema.finalData = data;
      if (tableStateData && tableStateData[0]) {
        tableStateData[0].body = data;
        tableStateData[0].busy = false;
        saveState(tableStateData[0], tableStateData[1], tableStateData[2]);
      }
      if (schema.content[0].ref) {
        schema.content[0].ref.setData(data);
      }
    });
  };
  if (schema.content[0].ref) {
    schema.content[0].ref.setBusy(true);
    saveState = schema.content[0].ref.props.saveState;
    tableStateData = [
      schema.content[0].ref.state,
      schema.content[0].ref.props.schemaKey,
      schema.content[0].ref.props.data,
    ];
  }
  let body = {
    starttime: data.starttime.unix() * 1000,
    endtime: data.endtime.unix() * 1000,
  };
  if (window.showNoGpsFixData === true) {
    body.fixqfilter = false;
  }
  ReportAPIs.getPanicAlertHistory(body).then(handleSuccess, (r) => {
    handleSuccess({});
  });
};

const flipRangeWrap = flipRange.call(this, (report) => {
  report.schema.toolbar[4].onClick = report.odometerRange
    ? onFetchOdo(getHistory)
    : getHistory;
});
const download = (schema, data, store) => {
  let strictColumns =
    store.groupTree.children.filter((g) => (g.path || "").indexOf("1259") > -1)
      .length > 0; // kushalsslp
  if (schema.finalData) {
    let finalData = _.map(schema.finalData, (r) => {
      r = Object.assign({}, r);
      r.starttime = moment(r.starttime).format(dateFormat);
      r.endtime = moment(r.endtime).format(dateFormat);
      if (strictColumns) {
        r.startloc = stripLoc(r.startloc);
        r.endloc = stripLoc(r.endloc);
      }
      return r;
    });
    if (strictColumns) {
      finalData = _.map(finalData, (r) => {
        if (window.userInfo.SELF.pbl_report === "SHOW") {
          let head = schema.content[0].head;
          let newHead = [];
          for (let idx in head) {
            if (
              head[idx].key !== "cpk" &&
              head[idx].key !== "mileage" &&
              head[idx].key !== "idlingtime" &&
              head[idx].key !== "acidlingtime"
            ) {
              newHead.push(head[idx].key);
            }
          }
          return _.pick(r, newHead);
        }
        let headings = schema.content[0].head
          .filter((c) => (c.isShowable ? c.isShowable(data.vehicle) : true))
          .map((c) => c.key);
        return _.pick(r, headings);
      });
    }
    JSONToCSVConvertor(finalData, "Panic_alert_report", false);
  }
};

const schema = {
  key: "panic_alert_report",
  name: "Panic Alert Report",
  finalData:null,
  toolbar: [
    {
      key: "switch",
      type: schemaTypes.BUTTON,
      iconType: "class",
      icon: "fa fa-exchange",
      onClick: flipRangeWrap,
      tooltip: "Switch between date range and odometer",
      isShowable: canShowRangeSwitch,
    },
    {
      key: "starttime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "Start Date",
    },
    {
      key: "endtime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "End Date",
    },
    {
      key: "get_history",
      type: schemaTypes.BUTTON,
      name: "Get Panic Alert Report",
      onClick: getHistory,
    },
    {
      key: "download",
      type: schemaTypes.BUTTON,
      iconType: "class",
      icon: "fa fa-download",
      onClick: download,
    },
  ],
  content: [
    {
      key: "dataTable",
      type: schemaTypes.IN_TABLE,
      position: {
        width: 12,
        height: 12,
        left: 0,
        top: 0,
      },
      head: [
        { key: "vehicleno", name: "", name: "Vehicle No" },
        { key: "model", name: "Model" },
        {
          key: "time",
          name: " Time",
          type: "DATE",
          format: dateFormat,
          width: 1.5,
        },
        { key: "alarmtype", name: "Alarm Type" },
        { key: "executedby", name: "Executed by" },
        { key: "speed", name: "Speed" },
        {
          key: "location",
          name: "Location",
          width: 2,
          onClick: (d, item) => {
            if (item.lat != null) window.showInGoogleMaps(item.lat, item.lng);
          },
        },
      ],
    },
  ],
};
export default schema;
